import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const ROOT_ELEMENT_ID = 'root';
const ROOT_ELEMENT_NOT_FOUND_ERROR = `Element with id "${ROOT_ELEMENT_ID}" was not found`;
const container =
  document.getElementById(ROOT_ELEMENT_ID) ??
  (() => {
    throw new Error(ROOT_ELEMENT_NOT_FOUND_ERROR);
  })();
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// register worker inside public/workers/push-notification-worker.js
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const workerPath = `${window.location.origin}/workers/push-notification-worker.js`;

    navigator.serviceWorker
      .register(workerPath)
      .then((registration) => {
        console.info('Service Worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
      });
  });
}
